<template>
  <div id="blog-home">

    <v-layout column>
      <v-flex xs12 sm12 md12>
        <v-container fluid grid-list-md text-xs-left>
          <v-layout row wrap>
            <v-flex><h1 id="blog-title">{{ title }}</h1></v-flex>
          </v-layout>
        </v-container>
      </v-flex>
    </v-layout>

  </div>
</template>

<script>
export default {
  data () {
    return {
      title: 'BLOG'
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/layouts/blog/Blog.vue